module.exports = new __parcel__URL__("trucker.b2be2d80.jpg").toString();